import script from "./RemoveDeviceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveDeviceTable.vue?vue&type=script&setup=true&lang=ts"

import "./RemoveDeviceTable.vue?vue&type=style&index=0&id=157e7640&lang=css"

const __exports__ = script;

export default __exports__